/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState, useRef } from "react";
import { getArticuloData } from "../../services/ArticuloService";
import DatosAccesorio from "../consulta-articulo/DatosAccesorio.jsx";
import DatosArmazon from "../consulta-articulo/DatosArmazon.jsx";
import DatosAnteojoSol from "../consulta-articulo/DatosAnteojoSol.jsx";
import DatosBlock from "../consulta-articulo/DatosBlock.jsx";
import DatosFornitura from "../consulta-articulo/DatosFornitura.jsx";
import DatosLenteContacto from "../consulta-articulo/DatosLenteContacto.jsx";
import DatosMaterialLaboratorio from "../consulta-articulo/DatosMaterialLaboratorio.jsx";
import DatosSolucionLimpieza from "../consulta-articulo/DatosSolucionLimpieza.jsx";
import { v4 as uuidv4 } from 'uuid';
import { grey } from '@mui/material/colors';
import { limpiaCodigo } from "../../utils/utils.js";
import { formatMoney } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

const initialIngresoArticuloItem = {
  id: "",
  id_articulo: "",
  codigoArticulo: "",
  cantidad: 0,
  actualCosto: 0,
  porcentajeDescuento: 0,
  costoReal: 0,
  valorDolarActual: 0,
  actualCostoEnDolar: 0,
  subtotal: 0,
  iva: 0,
  total: 0,
};

let actionCrudDescription = "";
//
// ########################################################################### 
//
const IngresoArticuloDialog = ({
  actionCrud,
  ingresoArticuloItem,
  onSave,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [ingresoArticuloItemLocal, setIngresoArticuloItemLocal] = useState(initialIngresoArticuloItem);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tipoArticulo, setTipoArticulo] = useState("");
  const [articuloData, setArticuloData] = useState({});
  const [codigoArticuloDisabled, setCodigoArticuloDisabled] = useState(false);
  const textFieldRef = useRef(null);
  //
  // ################################################################################ 
  //
  useEffect(() => {

    if (actionCrud === "new") {
      actionCrudDescription = "Agregar"
    } else if (actionCrud === "update") {
      actionCrudDescription = "Editar"
    } else if (actionCrud === "view") {
      actionCrudDescription = "Ver"
    } else if (actionCrud === "delete") {
      actionCrudDescription = "Eliminar"
    }

    if (actionCrud !== "new") {
      loadArticulo(ingresoArticuloItem.codigo_articulo);
    }

    setIngresoArticuloItemLocal({
      ...ingresoArticuloItemLocal,
      id: ingresoArticuloItem.id ?? "",
      id_articulo: ingresoArticuloItem.id_articulo ?? "",
      codigoArticulo: ingresoArticuloItem.codigo_articulo ?? "",
      cantidad: Number(ingresoArticuloItem.cantidad ?? 0),
      actualCosto: Number(ingresoArticuloItem.costo_pesos ?? 0),
      porcentajeDescuento: Number(ingresoArticuloItem.porcentaje_descuento ?? 0),
      costoReal: Number(ingresoArticuloItem.costo_real ?? 0),
      valorDolarActual: Number(ingresoArticuloItem.valor_dolar_actual ?? 0),
      actualCostoEnDolar: Number(ingresoArticuloItem.costo_actual_en_dolar ?? 0),
      subtotal: Number(ingresoArticuloItem.subtotal ?? 0),
      iva: Number(ingresoArticuloItem.iva ?? 0),
      total: Number(ingresoArticuloItem.total ?? 0),
    });
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let finalValue = type === "checkbox" ? e.target.checked : value;
    if (name === "cantidad") {
      const filtered = String(value).replace(/\D/g, "");
      finalValue = filtered === "" ? 0 : parseInt(filtered, 10);
    }
    setIngresoArticuloItemLocal({
      ...ingresoArticuloItemLocal,
      [name]: finalValue,
    });
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // opcional, evita submit de form
      e.preventDefault();
      loadArticulo(ingresoArticuloItemLocal.codigoArticulo);
    }
  };
  //
  // ################################################################################ 
  //
  const loadArticulo = async (parCodigoArticulo) => {

    const _codigoArticulo = limpiaCodigo(parCodigoArticulo);

    if (!_codigoArticulo) {
      return;
    }

    if (_codigoArticulo.length > 20) {
      setMessage({
        messageText: "El código de artículo no es válido",
        severity: "warning",
      });
      setShowMessage(true);
      return;
    }

    setIngresoArticuloItemLocal({
      ...ingresoArticuloItemLocal,
      codigoArticulo: _codigoArticulo,
    });

    loadArticuloData(_codigoArticulo);
    textFieldRef.current?.focus();
  };
  //
  // ################################################################################
  //
  const loadArticuloData = async (parCodigoArticulo) => {

    let _params = {
      codigo: parCodigoArticulo,
    };
    setIsDoingSomething(true);
    const response = await getArticuloData(_params);
    setIsDoingSomething(false);

    if (response.ok) {

      const _tipoArticulo = response.data.data ? response.data.data[0].tipo_articulo : "";

      if ([
        "cristal",
        "servicio",
        "tratamiento"
      ].includes(_tipoArticulo)) {
        setMessage({
          severity: "error",
          messageText: "El código ingresado es de un tipo de artículo no permitido en este tipo Ingreso de Artículos",
        });
        setShowMessage(true);
        return;
      };

      setIngresoArticuloItemLocal((ingresoArticuloItemLocal) => ({
        ...ingresoArticuloItemLocal,
        valorDolarActual: response.data.data[0].valor_dolar_actual,
        valorTasaIva: response.data.data[0].valor_tasa_iva,
        tipoArticulo: response.data.data[0].tipo_articulo,
      }));

      setArticuloData(response.data.data[0]);
      setTipoArticulo(response.data.data[0].tipo_articulo);
      setCodigoArticuloDisabled(true);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ######################################22##########################################
  //
  const cleanArticulo = () => {

    setIngresoArticuloItemLocal({
      id: "",
      id_articulo: "",
      codigoArticulo: "",
      cantidad: 0,
      actualCosto: 0,
      porcentajeDescuento: 0,
      costoReal: 0,
      valorDolarActual: 0,
      actualCostoEnDolar: 0,
      subtotal: 0,
      iva: 0,
      total: 0,
    })

    setTipoArticulo("");
    setArticuloData({});
    setCodigoArticuloDisabled(false);
  }
  //
  // ################################################################################
  //
  const calculaValores = () => {

    if (ingresoArticuloItemLocal.cantidad === 0) {
      setIngresoArticuloItemLocal({
        ...ingresoArticuloItemLocal,
        costoReal: 0,
        actualCostoEnDolar: 0,
        subtotal: 0,
        iva: 0,
        total: 0,
      });
      return;
    }

    const _costoReal = ingresoArticuloItemLocal.actualCosto - (ingresoArticuloItemLocal.actualCosto * ingresoArticuloItemLocal.porcentajeDescuento / 100);
    const _actualCostoEnDolar = ingresoArticuloItemLocal.valorDolarActual > 0 ? _costoReal / ingresoArticuloItemLocal.valorDolarActual : 0;
    const _subtotal = ingresoArticuloItemLocal.cantidad * _costoReal;
    const _iva = _subtotal * ingresoArticuloItemLocal.valorTasaIva / 100;
    const _total = _subtotal + _iva;
    setIngresoArticuloItemLocal({
      ...ingresoArticuloItemLocal,
      costoReal: Math.round(_costoReal * 100) / 100,
      actualCostoEnDolar: Math.round(_actualCostoEnDolar * 100) / 100,
      subtotal: Math.round(_subtotal * 100) / 100,
      iva: Math.round(_iva * 100) / 100,
      total: Math.round(_total * 100) / 100,
    });
  }
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (actionCrud === "new" || actionCrud === "update") {

      if (!ingresoArticuloItemLocal.codigoArticulo) {
        setMessage({
          severity: "error",
          messageText: "El código de artículo no es válido",
        });
        setShowMessage(true);
        return;
      }

      if (ingresoArticuloItemLocal.cantidad < 1 || isNaN(ingresoArticuloItemLocal.cantidad)) {
        setMessage({
          severity: "error",
          messageText: "La cantidad ingresada no es válida",
        });
        setShowMessage(true);
        return;
      }

      if (ingresoArticuloItemLocal.porcentajeDescuento >= 100) {
        setMessage({
          severity: "error",
          messageText: "El porcentaje de descuento ingresado no es válido",
        });
        setShowMessage(true);
        return;
      }

      if (ingresoArticuloItemLocal.actualCosto === 0 || isNaN(ingresoArticuloItemLocal.actualCosto)) {
        setMessage({
          severity: "error",
          messageText: "El costo ingresado no es válido",
        });
        setShowMessage(true);
        return;
      }

      if (ingresoArticuloItemLocal.porcentajeDescuento < 0 || isNaN(ingresoArticuloItemLocal.porcentajeDescuento)) {
        setMessage({
          severity: "error",
          messageText: "El porcentaje de descuento ingresado no es válido",
        });
        setShowMessage(true);
        return;
      }
    }

    const _ingresoArticuloItem = {
      id: actionCrud === "new" ? uuidv4() : ingresoArticuloItemLocal.id,
      id_articulo: articuloData.id,
      codigo_articulo: articuloData.codigo,
      descripcion_articulo: articuloData.descripcion_compuesta,
      modelo_articulo: articuloData.modelo ? articuloData.modelo : "",
      cantidad: Number(ingresoArticuloItemLocal.cantidad),
      costo_pesos: Number(ingresoArticuloItemLocal.actualCosto),
      porcentaje_descuento: Number(ingresoArticuloItemLocal.porcentajeDescuento),
      costo_real: Number(ingresoArticuloItemLocal.costoReal),
      valor_dolar_actual: Number(ingresoArticuloItemLocal.valorDolarActual),
      costo_actual_en_dolar: Number(ingresoArticuloItemLocal.actualCostoEnDolar),
      subtotal: Number(ingresoArticuloItemLocal.subtotal),
      valor_tasa_iva: Number(ingresoArticuloItemLocal.valorTasaIva),
      iva: Number(ingresoArticuloItemLocal.iva),
      total: Number(ingresoArticuloItemLocal.total),
      tipo_articulo: ingresoArticuloItemLocal.tipoArticulo,
    };

    onSave(_ingresoArticuloItem, actionCrud);

    if (actionCrud === "new") {
      cleanArticulo();
    } else {
      onClose();
    }
  };
  //
  // ################################################################################
  //
  const handleChangeNumber = (e) => {
    const _numero = e.target.value;
    if (/^\d*\.?\d*$/.test(_numero)) {
      setIngresoArticuloItemLocal({
        ...ingresoArticuloItemLocal,
        [e.target.name]: _numero,
      });
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="lg"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrudDescription} Artículo
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="codigoArticulo"
                sx={{ width: "100%" }}
                label="Código de Artículo"
                size="small"
                inputProps={{
                  autoComplete: "off",
                }}
                name="codigoArticulo"
                value={ingresoArticuloItemLocal.codigoArticulo ?? ""}
                variant="outlined"
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                autoFocus
                disabled={codigoArticuloDisabled || actionCrud === "update" || actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            {actionCrud === "new" && (
              <Grid item xs={8}>
                <Tooltip title="buscar">
                  <Fab
                    sx={{ ml: 1, mr: 1 }}
                    color="primary"
                    aria-label="add"
                    size="small"
                    onClick={() => loadArticulo(ingresoArticuloItemLocal.codigoArticulo)}
                    disabled={codigoArticuloDisabled || actionCrud === "view" || actionCrud === "delete"}
                  >
                    <SearchIcon />
                  </Fab>
                </Tooltip>

                <Tooltip title="limpiar">
                  <Fab
                    sx={{ ml: 1, mr: 1 }}
                    color="outlined"
                    aria-label="add"
                    size="small"
                    onClick={cleanArticulo}
                    disabled={actionCrud === "view" || actionCrud === "delete"}
                  >
                    <CleaningServicesIcon />
                  </Fab>
                </Tooltip>
              </Grid>
            )}

            {tipoArticulo === "" && (
              <Grid item xs={12} sx={{ mr: 1, mb: 1 }}>
                <Card>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      ...
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {tipoArticulo === "accesorio" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosAccesorio articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "armazon" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosArmazon articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "anteojo-sol" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosAnteojoSol articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "block" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosBlock articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}


            {tipoArticulo === "fornitura" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosFornitura articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "lente-contacto" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosLenteContacto articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "material-laboratorio" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosMaterialLaboratorio articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "solucion-limpieza" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosSolucionLimpieza articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            <Grid container spacing={1} sx={{ mt: 2 }}>
              <Grid item xs={12} sm={12} md={1} lg={1}>
                <TextField
                  id="cantidad"
                  inputRef={textFieldRef}
                  sx={{
                    flex: 1,
                    "& input": {
                      textAlign: "center",
                    },
                    "& input[type=number]::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input[type=number]::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  }}
                  size="small"
                  label="Cantidad"
                  variant="outlined"
                  name="cantidad"
                  type="text"
                  value={ingresoArticuloItemLocal.cantidad}
                  onChange={handleChangeNumber}
                  inputMode="numeric"
                  onBlur={calculaValores}
                  onFocus={(e) => e.target.select()}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="actualCosto"
                  sx={{
                    flex: 1,
                    "& input": {
                      textAlign: "right",
                    },
                    "& input[type=number]::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input[type=number]::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  }}
                  size="small"
                  label="Neto"
                  variant="outlined"
                  name="actualCosto"
                  type="text"
                  value={ingresoArticuloItemLocal.actualCosto}
                  onChange={handleChangeNumber}
                  inputMode="numeric"
                  onBlur={calculaValores}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={1} lg={1}>
                <TextField
                  id="porcentajeDescuento"
                  sx={{
                    flex: 1,
                    "& input": {
                      textAlign: "center",
                    },
                    "& input[type=number]::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input[type=number]::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  }}
                  size="small"
                  label="% Desc"
                  variant="outlined"
                  name="porcentajeDescuento"
                  type="text"
                  value={ingresoArticuloItemLocal.porcentajeDescuento}
                  onChange={handleChangeNumber}
                  inputMode="numeric"
                  onBlur={calculaValores}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ mt: 1, mb: 2 }}>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="costoReal"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  label="Costo Real"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    style: { textAlign: "right" },
                  }}
                  name="costoReal"
                  value={formatMoney(ingresoArticuloItemLocal.costoReal)}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="actualCostoEnDolar"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  label="Costo en U$S"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    style: { textAlign: "right" },
                  }}
                  name="actualCostoEnDolar"
                  value={formatMoney(ingresoArticuloItemLocal.actualCostoEnDolar)}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="subtotal"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  label="Subtotal"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    style: { textAlign: "right" },
                  }}
                  name="subtotal"
                  value={formatMoney(ingresoArticuloItemLocal.subtotal)}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="iva"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  label="IVA"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    style: { textAlign: "right" },
                  }}
                  name="iva"
                  value={formatMoney(ingresoArticuloItemLocal.iva)}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="total"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: grey[300],
                    },
                  }}
                  label="Total"
                  variant="outlined"
                  size="small"
                  inputProps={{
                    style: { textAlign: "right" },
                  }}
                  name="total"
                  value={formatMoney(ingresoArticuloItemLocal.total)}
                  disabled={true}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
            >
              {actionCrud !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  startIcon={actionCrud === "delete" ? <RemoveCircleOutlineIcon /> : <SaveIcon />}
                  color={actionCrud === "delete" ? "error" : "primary"}
                >
                  {actionCrud === "delete" ? "Eliminar" : "Guardar"}
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCloseDialog}
              >
                {actionCrud === "view" ? "Cerrar" : "Cancelar"}
              </Button>
            </Box>
          </Grid>
        </DialogContent >
      </Dialog >

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default IngresoArticuloDialog;
